export enum LegalNature {
    Person = "Person",
}